<template>
    <div>
        <!-- 头部组件 -->
        <HeaderPage href="/products" />

        <!-- 面包屑导航（动态渲染当前页面名称） -->
        <div class="bread">
            <div class="wrap">
                <router-link to="/">首页</router-link>
                &gt; <router-link to="">服务项目</router-link>
                &gt; <router-link to="">{{ currentDetail?.title }}</router-link>
            </div>
        </div>

        <div class="newsView">
            <div class="wrap">
                <div class="newsHead wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <h1>{{ currentDetail?.title}}</h1>
                </div>

                <!-- 富文本框太大 mock数据放不下 -->
                <div v-if="pid === 6" class="text wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">
                    <p>各市、县（市、区）物价局，省安监局：</p>
                    <p>为贯彻落实全省深化行政审批制度改革电视电话会议精神，切实抓好行政审批前置的中介和专业服务收费清理规范工作，按照《浙江省深化行政审批制度改革实施方案》和省监察厅《关于开展行政审批前置中介服务项目及相关中介机构清理工作的通知》（浙监明电〔2013〕1号）要求，现就规范安全评价收费等有关事项通知如下：
                    </p>
                    <p>二、安全评价收费应当遵循公开公正、诚实守信、自愿有偿的原则，委托方可自主选择具备相应资质的安全评价机构，安全评价机构接受委托，应与委托方签订合同，明确具体收费标准及双方的权利和义务。
                    </p>
                    <p>三、以上规定自2013年11月1日起执行，执行中的情况和问题请及时反映。</p>
                    <p>&nbsp;</p>
                    <p>附件：浙江省安全评价收费标准</p>
                    <p style="text-align: right;">浙江省物价局</p>
                    <p style="text-align: right;">2013年9月26日</p>
                    <p style="text-align: right;">&nbsp;</p>
                    <p>&nbsp;</p>
                    <p>附件</p>
                    <p>浙江省安全评价收费标准</p>
                    <p><strong>一、一般项目安全评价基准收费表</strong></p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>总投资额</p>
                                    <p>（亿元）</p>
                                </td>
                                <td width="85" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≤0.05</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.05-0.1</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.1-0.2</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.2-0.5</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.5-1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>基本收费</p>
                                    <p>(万元)</p>
                                </td>
                                <td width="85" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.6</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.6-2.8</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2.8-5.2</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5.2-6.8</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>6.8-9</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>总投资额</p>
                                    <p>（亿元）</p>
                                </td>
                                <td width="85" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0-2.0</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2.0-5.0</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5.0-10</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥10</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>基本收费</p>
                                    <p>(万元)</p>
                                </td>
                                <td width="85" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>9-12.6</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>12.6-21</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>21-31.5</p>
                                </td>
                                <td width="99" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>×0.2‰+11.5</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>总投资额计费说明：</p>
                    <p>（1）安全预评价的总投资额为可行性研究报告中的估算总投资额，不包括土地征用费和流动资金；</p>
                    <p>（2）安全验收评价的总投资额为实际总投资额；</p>
                    <p>（3）安全现状评价的总投资额为实际资产规模；</p>
                    <p>（4）专项安全评价的总投资额为安评直接涉及的生产和储存装置及公用工程的资产规模。</p>
                    <p>表2 行业调整系数</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>行业</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>调整系数</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1. 煤炭开采和洗选业</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.3</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2. 金属、非金属矿及其他矿采选业</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3. 石油和天然气开采业</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>4. 石油加工业，化学原料、化学品及医药制造业，燃气生产及供应业，炼焦业</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5. 烟花爆竹制造业，民用爆破器材制造业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>6．尾矿库</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>7. 房屋和土木工程建筑业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>8．管道运输业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>9．仓储业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10. 水利业，水电工程业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>11. 火力发电业，热力生产和供应业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>12．风力发电业，太阳能发电业，再生能源发电业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>13．核工业设施</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>14．黑色、有色金属冶炼及压延加工业，金属制品业，非金属矿物制品业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>15. 铁路运输业，城市轨道交通及辅助设施</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>16. 公路</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>17. 港口码头</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>18. 机械设备制造业，电器制造业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.8</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="424" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>19．轻工业，纺织业，烟草加工制造业</p>
                                </td>
                                <td width="165" valign="top"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.8</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>表3 评价类别系数</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="69" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>类别</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>安全预评价</p>
                                </td>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>安全验收</p>
                                    <p>评价</p>
                                </td>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>安全现状</p>
                                    <p>评价</p>
                                </td>
                                <td width="206" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>危险/剧毒化学品</p>
                                    <p>储存、使用专项</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="69" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>类别</p>
                                    <p>系数</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2-1.5</p>
                                </td>
                                <td width="112" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2</p>
                                </td>
                                <td width="206" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>表4 风险度系数</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="83" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>风险度</p>
                                </td>
                                <td width="124" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>风险度系数</p>
                                </td>
                                <td width="373" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>说明</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>特别高</p>
                                </td>
                                <td width="124" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.6</p>
                                </td>
                                <td width="373" valign="center" rowspan="4"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>生产、储存装置的危险程度、发生特大或重大伤亡事故的可能性、有无重大危险源、是否成熟工艺、是露天矿山还是地下矿山等。</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>高</p>
                                </td>
                                <td width="124" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.3</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>中</p>
                                </td>
                                <td width="124" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="83" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>低</p>
                                </td>
                                <td width="124" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.8</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>表5 复杂程度系数</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>复杂程度</p>
                                </td>
                                <td width="146" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>复杂程度系数</p>
                                </td>
                                <td width="310" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>说明</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>难</p>
                                </td>
                                <td width="146" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.2</p>
                                </td>
                                <td width="310" valign="center" rowspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>工作难度较大、地理位置偏远、危险因素复杂、基础资料不全等。</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>一般</p>
                                </td>
                                <td width="146" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>简单</p>
                                </td>
                                <td width="146" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.8</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>安全评价服务收费按以下公式计算：</p>
                    <p>安全评价费=项目安全评价基准收费×行业调整系数×资质等级系数×修正系数</p>
                    <p>收费计算说明：</p>
                    <p>（1）项目安全评价基准收费见《一般项目安全评价基准收费表》，在投资额区间内可采用直线插入法计算；</p>
                    <p>（2）行业调整系数见表2，资质等级系数为甲级机构1.1-1.3，乙级机构1.0；</p>
                    <p>（3）修正系数为评价类别系数、风险度系数、复杂程度系数的乘积，见表3、4、5。</p>
                    <p><br></p>
                    <p><strong>二、 非煤矿山安全评价收费标准表</strong></p>
                    <p></p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="181" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>生产能力</p>
                                </td>
                                <td width="170" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1 万吨/年以下</p>
                                </td>
                                <td width="214" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>每提高1万吨</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="181" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>地下矿山收费</p>
                                </td>
                                <td width="170" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3.2万元</p>
                                </td>
                                <td width="214" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>增加0.8万元</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="181" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>生产能力</p>
                                </td>
                                <td width="170" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>20万吨/年以下</p>
                                </td>
                                <td width="214" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>每提高10万吨</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="181" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>露天矿山收费</p>
                                </td>
                                <td width="170" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2.4万元</p>
                                </td>
                                <td width="214" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>增加0.4万元</p>
                                </td>
                            </tr>
                        </tbody>
                    </table><br>
                    <p></p>
                    <p><strong>三、尾矿库安全评价收费标准表</strong></p>
                    <p></p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="118" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>等级</p>
                                </td>
                                <td width="98" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>一</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>二</p>
                                </td>
                                <td width="96" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>三</p>
                                </td>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>四</p>
                                </td>
                                <td width="86" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>五</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="118" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>全库容V</p>
                                    <p>(万m3)</p>
                                </td>
                                <td width="98" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>二等库具备提高等级条件者</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥10000</p>
                                </td>
                                <td width="96" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1000≤V</p>
                                    <p>＜10000</p>
                                </td>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>100≤V＜1000</p>
                                </td>
                                <td width="86" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>＜100</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="118" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>坝高H（m）</p>
                                </td>
                                <td width="98" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>同上</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥100</p>
                                </td>
                                <td width="96" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>60≤H＜100</p>
                                </td>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>30≤H＜60</p>
                                </td>
                                <td width="86" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>H＜30</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="118" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>收费（万元）</p>
                                </td>
                                <td width="98" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10.5</p>
                                </td>
                                <td width="84" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>8.4</p>
                                </td>
                                <td width="96" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>7</p>
                                </td>
                                <td width="106" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>4.9</p>
                                </td>
                                <td width="86" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3.5</p>
                                </td>
                            </tr>
                        </tbody>
                    </table><br>
                    <p></p>
                    <p><strong>四、采掘施工企业安全评估（价）收费标准表</strong></p>
                    <p></p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="315" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>企业资质等级</p>
                                </td>
                                <td width="79" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>三级</p>
                                </td>
                                <td width="97" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>二级</p>
                                </td>
                                <td width="73" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>一级</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="315" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>土石方工程专业承包收费(万元)</p>
                                </td>
                                <td width="79" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2.4</p>
                                </td>
                                <td width="97" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3.2</p>
                                </td>
                                <td width="73" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>4.8</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="315" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>矿山工程施工总承包收费(万元)</p>
                                </td>
                                <td width="79" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3.6</p>
                                </td>
                                <td width="97" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>4.8</p>
                                </td>
                                <td width="73" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>7.2</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="565" valign="center" colspan="4"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>说明:施工安全生产现场安全评估（价）原则上评估一个现场,每增加一个评估现场加收1.5-2万元，施工现场在省外的另加收1.5-2万元。有煤矿等高风险采掘施工项目的施工企业，可在上述计价基础上乘1.5-2.0的风险系数。
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table><br>
                    <p></p>
                    <p><strong>五、危险化学品专项安全评价收费</strong></p>
                    <p>1、加油站安全评价收费标准表</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="89" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>规模</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>一级站</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>二级站</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>三级站</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>农村网点</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="89" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>收费（元）</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>6000</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5500</p>
                                </td>
                                <td width="105" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000</p>
                                </td>
                                <td width="165" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>4000</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="568" valign="center" colspan="5"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>说明：（1）加油站规模等级按国家标准执行；（2）加油、加气联合站可在上述计价基础上乘1.4的系数；（3）新建加油站的设立评价可在上述计价基础上乘1.5-2的系数，验收评价可乘1.7-2.5的系数。
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>2、汽车加气站、液化气充装站安全评价收费</p>
                    <p>按照一级加油站收费标准执行，联合站可在上述计价基础上乘1.3的系数；液化气体按一级加油站收费基础上乘1.2系数，其他气体按一级加油站收费基础上乘0.8系数。</p>
                    <p>3 、危险化学品储存和经营单位安全评价收费标准</p>
                    <p>（1）危险化学品储存单位</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>气体、液体储存规模</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>安全评价费用（万元）</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅰ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>按一般项目安全评价基准收费表执行</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅱ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0—2.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅲ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.5—1.0</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>危险化学品单一库规模</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>安全评价费用（万元）</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅰ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>按一般项目安全评价基准收费表执行</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅱ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.8</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="260" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>Ⅲ类</p>
                                </td>
                                <td width="269" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.5</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="529" valign="center" colspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>注:危险化学品综合仓库安全评价费根据工作量按上述标准的1.0∽5.0倍确定。</p>
                                    <p>经营单位类型：Ⅰ类：拥有储存气体10000m3以上或液体1000m3以上的储存设施，库房或货场总面积大于9000m2的大型仓库。
                                        Ⅱ类：拥有储存气体1000—10000m3或液体100—1000m3的储存设施，库房或货场总面积在550—9000m2之间的中型仓库；申领甲种《危险化学品经营许可证》，经营剧毒化学品、成品油和运输工具用液化气的。Ⅲ类：拥有储存气体1000m3以下或液体100m3以下的储存设施，库房或货场总面积小于550m2的小型仓库。
                                    </p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>（2） 危险化学品零售经营单位</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="161" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>经营范围</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>收费标准（元）</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>品种数量X（个）</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="161" valign="center" rowspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>剧毒化学品</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+300/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≤10</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+200/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10＜X＜50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+100/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="161" valign="center" rowspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>其它化学品</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+200/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≤10</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+100/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10＜X＜50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+50/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="161" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>油漆店</p>
                                </td>
                                <td width="361" valign="center" colspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2000-3000</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="522" valign="center" colspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>注：品种数按涉及到的危规号数量确定，有仓储经营时，另加场所、设施及储存装置的安全评价收费。</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>（3）危险化学品批发经营单位</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr class="firstRow">
                                <td width="161" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>经营范围</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>收费标准（元）</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>品种数量（个）</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="161" valign="center" rowspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>剧毒化学品</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+400/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≤10</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+300/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10＜X＜50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>5000+200/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="161" valign="center" rowspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>其它化学品</p>
                                </td>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+300/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≤10</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+200/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>10＜X＜50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="195" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3000+100/每品种</p>
                                </td>
                                <td width="166" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>≥50</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="522" valign="center" colspan="3"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>注：品种数按涉及到的危规号数量确定，有仓储经营时，另加场所、设施及储存装置的安全评价收费。</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p>（4）剧毒化学品使用单位</p>
                    <p>少量使用性质，如实验室用，按3000-6000元标准收费。使用量大时，按一般项目安全评价基准收费表执行。</p>
                    <p>六、烟花爆竹专项安全评价收费标准表</p>
                    <table cellspacing="0" align="center">
                        <tbody>
                            <tr style="height: 21px" class="firstRow">
                                <td width="79" valign="center" rowspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>类别</p>
                                </td>
                                <td width="227" valign="center" rowspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>项目或年销售额</p>
                                </td>
                                <td width="236" valign="center" rowspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>基价（万元）</p>
                                    <p>+年产值×比例</p>
                                </td>
                                <td width="406" colspan="3"
                                    style="border-width: 1px; border-style: solid; border-color: initial;"><br></td>
                            </tr>
                            <tr>
                                <td width="79" valign="center" rowspan="5"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>生产</p>
                                    <p>单位</p>
                                </td>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>爆竹生产</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0+3‰</p>
                                </td>
                            </tr>
                            <tr>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>烟花生产</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.5+4‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>礼花弹</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>3.0+5‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>火药</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.0+5‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>引线</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>0.3+1‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="79" valign="center" rowspan="2"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>销售</p>
                                    <p>批发</p>
                                </td>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>500万元以下</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>1.5＋2‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                            <tr>
                                <td width="227" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>500万元以上</p>
                                </td>
                                <td width="236" valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <p>2.0+1.5‰</p>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                                <td valign="center"
                                    style="padding: 0px; border-width: 1px; border-style: solid; border-color: initial;">
                                    <br>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p><br></p>
                </div>

                <div class="text wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;" v-else>
                    <!-- 加载状态 -->
                    <div v-if="isLoading" class="loading-state">
                        <p>正在加载内容...</p>
                    </div>

                    <!-- 错误状态 -->
                    <div v-else-if="hasError" class="error-state">
                        <p>内容加载失败，请稍后重试</p>
                    </div>

                    <!-- 富文本内容渲染 -->
                    <div v-else-if="currentDetail?.content" class="rich-content" v-html="currentDetail.content"></div>

                    <!-- 无内容状态 -->
                    <div v-else class="no-content">
                        <p>暂无内容</p>
                    </div>
                </div>
                <!-- <router-link to="/products">返回</router-link> -->
            </div>
        </div>
        <!-- 底部组件 -->
        <FooterPage />
    </div>
</template>

<script setup>
// 1. 引入所需依赖
import HeaderPage from '@/components/HeaderPage.vue'
import FooterPage from '@/components/FooterPage.vue'
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import axios from 'axios'
// import { getWebsiteData } from '@/utils/api';


const route = useRoute()


const currentDetail = ref({}) // 存储接口返回的详情数据（标题、内容等）
const isLoading = ref(true) // 加载状态
const hasError = ref(false) // 错误状态

const pid = ref(null)
pid.value =  +route.query.id

watch(() => route.params.id, (newId, oldId) => {
  console.log('路由参数变化:', oldId, '→', newId)
  pid.value = newId
  fetchData() // 自定义的重新加载逻辑
})

const fetchData = async () => {
    try {
        isLoading.value = true
        hasError.value = false

        // mock
        const res = await axios.get('/mock/productList.json'); // 本地Mock文件路径
        if (res.data.code === 200) {
            currentDetail.value = res.data.data.find(item => item.id === pid.value)
        }
        // const params = {
        //     title: route.query.title
        // };
        // const res = await getWebsiteData(params);

        // if (res.data && res.data.list && res.data.list.length > 0) {
        //     currentDetail.value = res.data.list[0]
        // } else {
        //     hasError.value = true
        // }

    } catch (err) {
        console.error('获取失败：', err);
        hasError.value = true
    } finally {
        isLoading.value = false
    }
}

// 4. 页面挂载时执行接口请求
onMounted(async () => {
    fetchData()
})
</script>

<style>
/* 原有样式保留，新增加载/错误状态样式 */
.bread {
    line-height: 70px;
    color: #666;
    margin-top: 140px;
}

.bread a {
    color: #666;
    text-decoration: none;
}

.newsView {
    padding: 60px 0 100px;
}

table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
    font-size: 14px;
}

th,
td {
    border: 1px solid #ccc;
    padding: 8px 10px;
    text-align: center;
}

th {
    background: #f2f2f2;
}

/* 加载状态样式 */
.loading-state {
    text-align: center;
    padding: 50px 0;
    color: #666;
    font-size: 16px;
}

/* 错误状态样式 */
.error-state {
    text-align: center;
    padding: 50px 0;
    color: #ff4d4f;
}

.back-btn {
    display: inline-block;
    margin-top: 20px;
    color: #42b983;
    text-decoration: none;
    border: 1px solid #42b983;
    padding: 8px 16px;
    border-radius: 4px;
}

/* 返回链接样式优化 */
.back-link {
    display: inline-block;
    margin-top: 30px;
    color: #42b983;
    text-decoration: none;
}

.back-link:hover {
    text-decoration: underline;
}

/* 富文本内容样式 */
.rich-content {
    line-height: 1.8;
    color: #333;
    font-size: 16px;
    word-wrap: break-word;
}

.rich-content p img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 富文本内图片样式 */
.rich-content img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* 富文本内段落样式 */
.rich-content p {
    margin: 16px 0;
    text-align: justify;
}

/* 富文本内标题样式 */
.rich-content h1,
.rich-content h2,
.rich-content h3,
.rich-content h4,
.rich-content h5,
.rich-content h6 {
    margin: 24px 0 16px 0;
    font-weight: bold;
    color: #2c3e50;
}

/* 富文本内列表样式 */
.rich-content ul,
.rich-content ol {
    margin: 16px 0;
    padding-left: 24px;
}

.rich-content li {
    margin: 8px 0;
}

/* 富文本内链接样式 */
.rich-content a {
    color: #42b983;
    text-decoration: none;
}

.rich-content a:hover {
    text-decoration: underline;
}

/* 富文本内代码样式 */
.rich-content code {
    background-color: #f5f5f5;
    padding: 2px 4px;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
}

.rich-content pre {
    background-color: #f5f5f5;
    padding: 16px;
    border-radius: 4px;
    overflow-x: auto;
    margin: 16px 0;
}

/* 富文本内表格样式 */
.rich-content table {
    width: 100%;
    border-collapse: collapse;
    margin: 20px 0;
}

.rich-content th,
.rich-content td {
    border: 1px solid #ddd;
    padding: 12px;
    text-align: left;
}

.rich-content th {
    background-color: #f8f9fa;
    font-weight: bold;
}

/* 富文本内引用样式 */
.rich-content blockquote {
    border-left: 4px solid #42b983;
    margin: 16px 0;
    padding: 16px 20px;
    background-color: #f8f9fa;
    font-style: italic;
}

/* 无内容状态样式 */
.no-content {
    text-align: center;
    padding: 50px 0;
    color: #999;
    font-size: 16px;
}
</style>